/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";
import {
  blackMaterial,
  metalicLightMaterial,
} from "../../../../common/materials";

const model = "/models/desk/chair.glb";

export default function Chair({ ...props }) {
  const group = useRef();
  const { nodes, materials } = useGLTF(model);
  return (
    <group ref={group} {...props} dispose={null}>
      <group position={[-2.25, 0.64, 1.66]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cube013.geometry}
          material={blackMaterial}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cube013_1.geometry}
          material={metalicLightMaterial}
        />
      </group>
      <group position={[-2.25, 0.01, 1.57]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cylinder003.geometry}
          material={blackMaterial}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cylinder003_1.geometry}
          material={metalicLightMaterial}
        />
      </group>
    </group>
  );
}

useGLTF.preload(model);
